import React from 'react'
import { Body, DifficultyLevelShape } from '@superhi/design'

import { API } from '../../../../../../api'

import { Wrapper } from './styles'

const TEXT: Record<API.VideoDifficultyLevel, string> = {
  BEGINNER: 'Beginner',
  INTERMEDIATE: 'Intermediate',
  ADVANCED: 'Advanced',
}

type Props = {
  difficultyLevel: API.VideoDifficultyLevel
}

export const DifficultyLevel: React.FC<Props> = ({ difficultyLevel }) => (
  <Wrapper>
    <DifficultyLevelShape difficultyLevel={difficultyLevel} />
    <Body level="3">{TEXT[difficultyLevel]}</Body>
  </Wrapper>
)

export default DifficultyLevel
